/* unplugin-vue-components disabled */import script from "./404.vue?vue&type=script&lang=ts&setup=true"
export * from "./404.vue?vue&type=script&lang=ts&setup=true"

import "./404.vue?vue&type=style&index=0&id=3d233df0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d233df0"]])

export default __exports__